module.exports = __webpack_public_path__ + "static/red-logo@2x-847419b9fb96f75b9faa3ae1afc70055.png";